import React, {useEffect, useMemo, useState} from 'react';
import {CacheType, ContentCategory} from "../../../../constant/CodeSpecNum";
import Search from "../../../../components/search/Search";
import {useTranslation} from "react-i18next";
import {SERVICE_REQUEST_HEADER} from "../../../../components/table/header/Headers";
import {useDispatch} from "react-redux";
import SearchSection from "../../../../components/search/SearchSection";
import {SearchProgressComboBox} from "../../../../components/select/SearchProgressComboBox";
import {deleteServiceRequests} from "../../../../api/serviceRequest/ServiceRequestService";
import {apiLoading} from "../../../../redux/slice/apiSlice";
import {handleActiveError, handleActiveToast} from "../../../../components/sonner/ToastBasic";
import {searchListener, searchWithChildren} from "../../../../components/commonmethod/simmsDrawerMethod";
import Selector from "../../../../components/selector/Selector";
import {getIndividualSetting, resetIndividualSetting, setIndividualSetting} from "../../../../api/user/UserAccountService";
import {extractObject, initHeaderOrders, nonObject, simmsColumnsToJsGridHeaders} from "../../../../components/commonmethod/CommonMethod";
import {useCacheRefresh} from "../../../../hooks/useCacheRefresh";
import SimmsInputSearch from "../../../../components/input/SimmsInputSearch";
import SimmsDrawerSearch from "../../../../components/drawer/simms/SimmsDrawerSearch";
import {SearchComboBox} from "../../../../components/select/SearchComboBox";
import {ToolbarDataTransfer} from "@bavuchoko/js-grid";
import SimmsJsGrid from "../../../../components/js-grid/SimmsJsGrid";
import {navigateWithChildTab, pickDetailTabTitle} from "../../../../components/pageTabs/pageTabsStorage";
import {useNavigate} from "react-router-dom";
import {useExcelDownloadClick} from "../../../../components/commonmethod/excelMethod";
import JsGridExcelGridOpenButton from "../../../../components/js-grid/JsGridExcelGridOpenButton";

export const rejected = [
    {id: "REJECT", name: "반려 상태"},
    {id: "NONE", name: "반려 외 상태"},
];

const ServiceRequestListType = ({data, date, pageInfo, dataHook}) => {
    const navigate = useNavigate();
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const refreshCache = useCacheRefresh();
    const {handleSearch, handlePageSizeChange, saveConditions, refresh, handleGridPageChange} = dataHook;
    const handleDownloadClick = useExcelDownloadClick(saveConditions);

    const [header, setHeader] = useState({order: SERVICE_REQUEST_HEADER, exclude: []});
    const searchDate = {startDate: saveConditions.startDate ?? date.startDate, endDate: saveConditions.endDate ?? date.endDate};

    useEffect(() => {
        getIndividualSetting().then((r) => {
            initHeaderOrders(r, SERVICE_REQUEST_HEADER, setHeader, [], () => {}, () => {}, 'service_request');
        });
    }, []);

    const handleRowClick = (row) => {
        const id = row?.id;
        if (id == null) return;
        navigateWithChildTab(navigate, {
            title: pickDetailTabTitle(row, "접수 상세"),
            url: `/serviceRequest/serviceRequest/${id}`,
        });
    };

    const deleteMultiItems = async (rows) => {
        if (!rows?.length) {
            window.alert(t('notSelected'));
            return;
        }
        if (!window.confirm("연관된 서비스신청도 모두 삭제됩니다.\n삭제하시겠습니까?")) {
            return;
        }
        dispatch(apiLoading(true));
        try {
            const ids = rows.map((row) => row.id).filter((id) => id != null);
            const response = await deleteServiceRequests({ids});
            if (response?.status === 200) {
                refreshCache(CacheType.SERVICE_REQUEST);
                refresh();
                handleActiveToast({message: t('removed')});
            } else if (response?.status === 201) {
                handleActiveError({message: response.data.title, description: response.data.reason});
            }
        } finally {
            dispatch(apiLoading(false));
        }
    };

    const serviceRequestJsGridHeader = useMemo(() => simmsColumnsToJsGridHeaders(header), [header]);
    const excelGridSearch = useMemo(() => extractObject(saveConditions), [saveConditions]);

    return (
        <div className="container-height">
            <Search refresh={refresh} entity={'service_request'} searchConditions={saveConditions} handleSearch={handleSearch} handlePageSizeChange={handlePageSizeChange}
                    searchBar={{placeHolder: '접수 신청번호, 신청제목'}} size detail date={searchDate} pageInfo={pageInfo}>
                <SearchSection>
                    <Selector showLabel onChange={(value) => searchWithChildren(handleSearch, 'serviceCode', extractObject(saveConditions), value)}
                                 data={saveConditions.serviceCode} recursive
                                 entity={"serviceCode"} title={"서비스코드"} />
                    <Selector showLabel
                                 onChange={(value) => searchListener(handleSearch, 'applier', extractObject(saveConditions), value)}
                                 data={saveConditions.applier}
                                 uniqueKey={"applier"}
                                 title={"요청자"} entity="userAccount">
                        <SimmsInputSearch type={'TEXT'} placeHolder={"사용자명"} />
                        <SimmsDrawerSearch showLabel title={'부서'} entity={'department'} target={'department'} recursive />
                        <SimmsDrawerSearch showLabel title={'업체'} entity={'company'} target={'company'} />
                    </Selector>
                    <Selector showLabel
                                 onChange={(value) => searchListener(handleSearch, 'requester', extractObject(saveConditions), value)}
                                 data={saveConditions.requester}
                                 uniqueKey={"requester"}
                                 title={"접수자"} entity="userAccount">
                        <SimmsInputSearch type={'TEXT'} placeHolder={"사용자명"} />
                        <SimmsDrawerSearch showLabel title={'부서'} entity={'department'} target={'department'} recursive />
                        <SimmsDrawerSearch showLabel title={'업체'} entity={'company'} target={'company'} />
                    </Selector>
                    <SearchProgressComboBox target={"progressNumericValue"} tableName={ContentCategory.SERVICE_REQUEST} value={saveConditions}
                                            onChange={(v) => nonObject(saveConditions, v, handleSearch, "progressNumericValue")}
                    />
                    <SearchComboBox title={"반려 여부"} code={rejected} target={"rejected"} value={saveConditions}
                                    onChange={(v) => nonObject(saveConditions, v, handleSearch, "rejected")}
                    />
                </SearchSection>
            </Search>

            <div className="container-height-body">
                <SimmsJsGrid
                    loading={dataHook.loading}
                    resizable={true}
                    data={data}
                    theme={'linear'}
                    style={{minHeight: 0, height: '100%'}}
                    header={serviceRequestJsGridHeader}
                    onHeaderSave={(v) => setIndividualSetting({headers: {service_request: v}})}
                    onHeaderReset={() => resetIndividualSetting('headers', 'service_request')}
                    enableRowSelection={true}
                    onRowClick={handleRowClick}
                    onPageChange={handleGridPageChange}
                    toolbarEnd={() => (
                        <div className="flex items-center gap-2">
                            <JsGridExcelGridOpenButton entityName="RequestExcel" search={excelGridSearch} />
                            <ToolbarDataTransfer
                                hint="선택 항목 삭제"
                                busyHint="삭제 중…"
                                overlayLabel="삭제 중…"
                                onTransfer={deleteMultiItems}
                            >
                                {(ctx) => (
                                    <button
                                        type="button"
                                        className="text-[13px] px-3 py-0.5 text-black rounded-4 border disabled:cursor-not-allowed"
                                        onClick={() => {
                                            if (ctx.selectedCount === 0) {
                                                window.alert(t('notSelected'));
                                                return;
                                            }
                                            void ctx.transferSelected();
                                        }}
                                    >
                                        삭제
                                    </button>
                                )}
                            </ToolbarDataTransfer>
                            <button
                                type="button"
                                className="text-[13px] px-3 py-0.5 border text-white bg-themeDark rounded-4"
                                onClick={() => navigate('/serviceRequest/serviceRequest/create')}
                            >
                                등록
                            </button>
                        </div>
                    )}
                />
            </div>
        </div>
    );
};

export default ServiceRequestListType;
